import React from "react";
import MtiButton from "../Buttons/MtiButton";
import "../../WarningView.css";
import Modal from "../Common/Modal";
import PlateTypeApi from "../../api/PlateTypeApi";
import "./BackupPlateTypeModalView.css";
import { sendNotification } from "../../redux/actions/NotificationAction";
import { ENotificationType } from "../../Model/ENotificationType";
import { useDispatch } from "react-redux";

type Props = {
  showBackupPlateType: boolean;
  setShowBackupPlateType: (show: boolean) => void;
  backupPlateTypeNote: string;
  setBackupPlateTypeNote: (note: string) => void;
  selectedPlateTypeId: number;
  selectedImagerIdentifier: string;
};

export default function BackupPlateTypeModalView({
  showBackupPlateType,
  setShowBackupPlateType,
  backupPlateTypeNote,
  setBackupPlateTypeNote,
  selectedPlateTypeId,
  selectedImagerIdentifier,
}: Props) {
  const dispatch = useDispatch();
  return (
    <Modal
      show={showBackupPlateType}
      hideOnBackdropClick={false}
      className="backup-plate-type-modal-view"
    >
      <Modal.Header
        className="backup-plate-type-modal-view-header"
        title="Backup Plate Type Definition"
        hideButtonEnabled={false}
      />
      <Modal.Body className="backup-plate-type-modal-view-content">
        <p>Enter note for plate definition backup.</p>
        <textarea
          value={backupPlateTypeNote}
          onChange={(e) => setBackupPlateTypeNote(e.target.value)}
        />
      </Modal.Body>
      <Modal.Footer className="backup-plate-type-modal-view-footer">
        <MtiButton
          size="large"
          disabled={backupPlateTypeNote.length == 0}
          onClick={() => {
            PlateTypeApi.backupPlateType(
              selectedPlateTypeId,
              selectedImagerIdentifier,
              backupPlateTypeNote
            )
              .then(() => {
                dispatch(
                  sendNotification(
                    ENotificationType.Success,
                    "Backup process has been done"
                  )
                );
              })
              .catch((reason) => {
                dispatch(sendNotification(ENotificationType.Error, reason));
              });
            setShowBackupPlateType(false);
            setBackupPlateTypeNote("");
          }}
        >
          OK
        </MtiButton>
        <MtiButton
          size="large"
          variant="secondary"
          style={{
            marginRight: 10,
          }}
          onClick={() => {
            setBackupPlateTypeNote("");
            setShowBackupPlateType(false);
          }}
        >
          Cancel
        </MtiButton>
      </Modal.Footer>
    </Modal>
  );
}
